import { call, put } from "redux-saga/effects";
import { apiRouting, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeletePickingQuarentineActions } from "store/ducks/picking-quarentines";

export function* deletePickingQuarentineRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiRouting.delete,
      `/picking-quarentines/${id}`
    );

    const { data } = responseBody;
    yield put(DeletePickingQuarentineActions.success(data));
    notify("success", "Carga deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeletePickingQuarentineActions.failure(errorMessage));
  }
}
